import React from 'react';

import { Icon, SmartLink } from 'components';
import type { Promo } from 'modules/promo';

import arrowRight from 'assets/svg/arrow-left.svg';
import './featuredTournamentsItem.scss';

interface Props {
    config: Promo.FeaturedConfig;
}

const FeaturedTournamentsItem: React.FC<Props> = ({ config }) => {
    const { name, linkToTournament } = config;

    if (!name || !linkToTournament) return null;

    return (
        <SmartLink styleName="container" to={linkToTournament}>
            <div styleName="name">{name}</div>
            <Icon styleName="arrow-icon" glyph={arrowRight} />
        </SmartLink>
    );
};

export default React.memo(FeaturedTournamentsItem);
